// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"334756f8","696":"f552393f"}[chunkId] + ".chunk.css";
};